/**
 * All Course Search scripts required should be included here.
 *
 * This is the file that Webpack is compiling into coursesearch.[hash].js
 */

import './sass/course-search.scss'
import './sass/course-search-calendar.scss'

$(document).ready(() => {
  $('#show-filters select').on('mousedown', function () {
    const selected = $(this).val()
    if (selected === 'Show filters') {
      $('#sidebar').css('max-height', '2000px')
    }
  })
  $('#show-filters select').on('change', function () {
    const selected = $(this).val()
    if (selected === 'Show filters') {
      $('#sidebar').css('max-height', '2000px')
    } else {
      $('#sidebar').css('max-height', '0px')
    }
  })

  const searchClient = algoliasearch('CPZQCV6WHC', '2813ce18acef256cec6b828fbb2d56cc')

  const encodedDepartments = {
    'bike-shop': 'Bike Shop',
    blacksmithing: 'Blacksmithing',
    ceramics: 'Ceramics',
    enameling: 'Enameling',
    'fire-performance': 'Fire & Performance',
    foundry: 'Foundry',
    'glass-blowing': 'Glass Blowing',
    'glass-casting-coldworking': 'Glass Casting & Coldworking',
    'glass-flameworking': 'Glass Flameworking',
    'glass-fusing-slumping': 'Glass Fusing & Slumping',
    jewelry: 'Jewelry',
    'kinetics-electronics': 'Kinetics & Electronics',
    leather: 'Leather',
    'leather-textiles-fine-arts': 'Leather, Textiles, & Fine Arts',
    'machine-shop': 'Machine Shop',
    moldmaking: 'Moldmaking',
    'neon-light': 'Neon & Light',
    stoneworking: 'Stoneworking',
    welding: 'Welding',
    woodworking: 'Woodworking',
    'youth-after-care': 'Youth After Care'
  };

  const encodedAudiences = {
    "family": "Family",
    "ages-16-plus": "Ages 16+",
    "ages-18-plus": "Ages 18+",
    "ages-12-18": "Ages 12-18",
    "ages-14-18": "Ages 14-18",
    "ages-8-11": "Ages 8-11",
    "all-ages": "All Ages"
  }

  const courseSearch = instantsearch({
    indexName: 'courses_sort_date',
    searchClient,
    routing: {
      router: instantsearch.routers.history({
        parseURL({ qsModule, location }) {
          const pathnameMatches = location.pathname.match(/course-search\/(.*?)\/?$/);
          let department = getDepartmentName(
            (pathnameMatches && pathnameMatches[1]) || ''
          );

          const { query = '', page } = qsModule.parse(
            location.search.slice(1)
          );

          let audience = null
          const search = location.search.substring(1);

          if (search !== "") {
            const myQuery = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === "" ? value : decodeURIComponent(value) })
            if (typeof myQuery.faudience !== "undefined" && !Array.isArray(myQuery.faudience)) {
              audience = myQuery.faudience.split(",")
            }
            if (typeof myQuery.fdepartment !== "undefined" && myQuery.fdepartment !== '') {
              department = getDepartmentName(myQuery.fdepartment.replace('/', ''))
            }
          }

          if (department == 'adult') {
            department = null
            audience = ['Ages 18+', 'Ages 16+', 'Family']
          } else if (department == 'youth') {
            department = null
            audience = ['Ages 8-11', 'Ages 12-18', 'Ages 14-18']
          } else if (department == '') {
            department = null
          } else {
            department = [department]
          }

          if (Array.isArray(audience)) {
            audience = getAudienceNames(audience)
          }

          return {
            query: decodeURIComponent(query),
            page,
            department: department,
            audience: audience
          };
        }
      }),
      stateMapping: {
        stateToRoute(uiState) {
          const indexUiState = uiState['courses_sort_date'] || {};

          return {
            query: indexUiState.query,
            page: indexUiState.page,
            department: indexUiState.refinementList && indexUiState.refinementList.department,
            audience: indexUiState.refinementList && indexUiState.refinementList.audience
          };
        },

        routeToState(routeState) {
          return {
            courses_sort_date: {
              refinementList: {
                department: routeState.department,
                audience: routeState.audience
              }
            }
          };
        }
      }
    }
  })

  function getDepartmentName(slug) {
    const decodedSlug = encodedDepartments[slug] || slug;

    return decodedSlug
      .split('+')
      .map(decodeURIComponent)
      .join(' ');
  }

  function getAudienceNames(slugs) {
    let decodedSlugs = [];
    for (const slug of slugs) {
      const decodedSlug = encodedAudiences[slug] || slug;
      decodedSlugs.push(decodedSlug);
    }

    return decodedSlugs;
  }

  const facet_ages = ['Family', 'Ages 8-11', 'Ages 12-18', 'Ages 14-18', 'Ages 16+', 'Ages 18+']
  const facet_days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Monday to Friday', 'Saturday', 'Sunday']
  const facet_time = ['Morning', 'Afternoon', 'Evening', 'All Day']

  function cruSorter(a, b, facet) {
    if (!facet.includes(a.name)) {
      return 1
    }
    if (!facet.includes(b.name)) {
      return -1
    }
    if (facet.indexOf(a.name) < facet.indexOf(b.name)) {
      return -1
    } else {
      return 1
    }
  }

  const datePicker = instantsearch.connectors.connectRange(
    (options, isFirstRendering) => {
      if (!isFirstRendering) return;

      const { refine } = options;

      // Replace Calendar 
      const container = document.querySelector('#calendar');
      container.innerHTML = `
        <div class="date-range">
          <input type="date" id="start-date" />
          <input type="date" id="end-date" />
        </div>
      `;

      const startDate = document.querySelector('#start-date');
      const endDate = document.querySelector('#end-date');

      // Set default dates
      startDate.value = new Date().toISOString().split('T')[0];
      endDate.value = new Date('12/31/2025').toISOString().split('T')[0];

      // Handle date changes
      [startDate, endDate].forEach(input => {
        input.addEventListener('change', () => {
          const start = new Date(startDate.value).getTime();
          const end = new Date(endDate.value).getTime();
          refine([start / 1000, end / 1000]);
        });
      });
    }
  )

  courseSearch.addWidgets([
    instantsearch.widgets.searchBox({
      container: '#searchbox',
      cssClasses: ['product-filter-field']
    }),
    instantsearch.widgets.refinementList({
      container: '#department',
      attribute: 'department',
      cssClasses: {
        list: '',
        labelText: 'term-name'
      },
      transformItems(items) {
        return items.map(function (item) {
          item.highlighted = (item.highlighted === 'Leather') ? 'Leather, Textiles, & Fine Arts' : item.highlighted;
          return item;
        });
      },
      sortBy: ['name:asc'],
      limit: 99

    }),
    instantsearch.widgets.rangeSlider({
      container: '#price-slider',
      attribute: 'price',
      min: 0,
      max: 2000,
      precision: 0,
      step: 10,
      pips: false
    }),
    instantsearch.widgets.refinementList({
      container: '#audience',
      attribute: 'audience',
      sortBy(a, b) {
        return cruSorter(a, b, facet_ages)
      }
    }),
    instantsearch.widgets.rangeSlider({
      container: '#remaining-slider',
      attribute: 'stocks',
      min: 0,
      max: 20,
      precision: 0,
      step: 1,
      pips: false
    }),
    instantsearch.widgets.toggleRefinement({
      container: '#remaining-refinement',
      attribute: 'is_in_stock',
      on: true,
      templates: {
        labelText: 'Hide out of stock classes'
      }
    }),
    instantsearch.widgets.refinementList({
      container: '#day-checklist',
      attribute: 'day',
      sortBy(a, b) {
        return cruSorter(a, b, facet_days)
      }
    }),
    instantsearch.widgets.refinementList({
      container: '#time-checklist',
      attribute: 'time_of_day',
      sortBy(a, b) {
        return cruSorter(a, b, facet_time)
      }
    }),
    instantsearch.widgets.refinementList({
      container: '#level-checklist',
      attribute: 'level',
      sortBy: ['name:asc']
    }),
    datePicker({
      attribute: 'start_dates'
    }),

    instantsearch.widgets.sortBy({
      container: '#sort-by-container',
      items: [
        { value: 'courses_sort_date', label: 'Sort By' },
        { value: 'courses', label: 'Alphabetical' },
        { value: 'courses_sort_date', label: 'Date' }
      ]
    }),

    instantsearch.widgets.pagination({
      container: '#pagination'
    }),

    instantsearch.widgets.hits({
      container: '#hits',
      cssClasses: {
        list: 'products clearfix products-3',
        item: 'product-grid-view product type-product'
      },
      templates: {
        item: `
	<a href="{{ url }}" class="product-images" aria-label="{{ title }}">
		<div class="fusion-out-of-stock {{is_in_stock}}">
			<div class="fusion-position-text">All classes are full → Join the waitlist</div>
		</div>
		<div class="featured-image">{{{ image }}}</div>
	</a>
	<div class="fusion-product-content">
		<div class="product-details">
			<div class="product-details-container">
			<h3 class="product-title fusion-responsive-typography-calculated" data-fontsize="18" data-lineheight="19.8px" style="--fontSize:18; line-height: 1.1; --minFontSize:18;">
				<a href="{{ url }}">{{ title }}</a>
			</h3>
			<div class="fusion-price-rating">
				<p class="card-tags">
					<span class="card-age">{{ audience }}</span><span class="card-format">{{ hours }} Hours</span>
				</p>
				<p>
					<b>Price: \${{ price_txt }}</b><br/>
					{{#member_price}}
					Member Price: \${{ member_price }}<br/>
          {{/member_price}}
					<b>Next class starts:</b> {{ next_date_txt }}
				</p>
			</div>
		</div>
		<div class="product-buttons">
			<div class="product-buttons-container clearfix">
				<a href="{{ url }}" class="" style="float:none;max-width:none;">See dates &amp; sign up →</a>
			</div>
		</div>
	</div>

	</div>
	`
      }
    })
  ])

  courseSearch.start()
})
